import { useRanking } from '@/data/hook/hackathon/useRanking';
import useManualQuery from '@/data/hook/query/v1/useManualQuery';
import { ProjectFilters } from '@/data/services/projectServices';
import { winnersQueryKeys } from '@/data/services/querykeys';
import Hackathon from '@/models/Hackathon';
import { Project } from '@/models/Project';
import { getWinnerByProjectId, getWinnersCount } from '@/utils/hackathon';
import { useState } from 'react';
import ProjectCarousel from './ProjectCarousel';

type ProjectCarouselProps = {
  hackathon: Hackathon;
  filters?: ProjectFilters;
  route?: string;
};

export default function ProjectCarouselRanking({
  filters,
  hackathon,
  route,
}: ProjectCarouselProps) {
  const [carrouselFilters, setCarrouselFilters] = useState({});
  const allFilters = { ...filters, ...carrouselFilters };

  const {
    results: projects,
    isInitialLoading,
    winners,
    isFetchingNextPage: fetchingNextPage,
    hasNextPage,
    queryKey,
    fetchNextPage,
    error,
  } = useRanking(hackathon, allFilters);
  const onFilter = (value: ProjectFilters) => {
    setCarrouselFilters(prev => ({ ...prev, ...value }));
  };

  const { update } = useManualQuery({ queryKey });

  const { updateItem: updateWinners } = useManualQuery(
    winnersQueryKeys.list({
      hackathonId: hackathon?.id,
      pageSize: getWinnersCount(),
    }),
  );

  const onMutate = (project: Project) => {
    update(project);
    const winner = getWinnerByProjectId(project.id, winners);
    if (!winner) return;
    winner.project = project;
    updateWinners(winner);
  };
  return (
    <ProjectCarousel
      route={route}
      section="ranking"
      error={error}
      filters={allFilters}
      onMutate={onMutate}
      onFilter={onFilter}
      projects={projects}
      fetchingNextPage={fetchingNextPage}
      hasNextPage={hasNextPage}
      isLoading={isInitialLoading}
      onReachEnd={fetchNextPage}
    />
  );
}
